RESOLVER_TYPE_CATEGORY